import { refreshPageVideo } from '../../../../../.globals/redux/actions';
export class VIDEO_CHANGE_STATUS {
    execute = (data, state, dispatch) => {
        const { videoDetailMediaRedux } = state

        if (data.key == "STATUS" && data.ids && data.ids.find(x => x.deviceId == videoDetailMediaRedux?.data?.deviceData?.deviceId && x.rowId == videoDetailMediaRedux?.data?.deviceData?.id))
            dispatch(refreshPageVideo(data));
    };
}